import React from "react";

const terms = [
  "INFLATION",
  "PRICE CEILINGS",
  "WAGES",
  "REGULATION",
  "MARKET FAILURE",
  "EXTERNALITIES",
  "ANTITRUST",
  "FISCAL POLICY",
  "MONETARY POLICY",
  "DEREGULATION",
  "COMPLIANCE COSTS",
  "LABOR STANDARDS",
  "CONSUMER PROTECTION",
  "OSHA",
  "FDA",
  "FTC",
  "DODD-FRANK",
];

const separator = " — ";

export default function Marquee() {
  const content = terms.map((t) => `${t}${separator}`).join("");

  return (
    <div
      data-testid="marquee-ribbon"
      style={{
        backgroundColor: "#0A0A0A",
        borderTop: "1px solid #1A1A1A",
        borderBottom: "1px solid #1A1A1A",
        overflow: "hidden",
        padding: "14px 0",
      }}
    >
      <div className="marquee-track">
        {[...Array(4)].map((_, i) => (
          <span
            key={i}
            style={{
              fontFamily: "'IBM Plex Mono', monospace",
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              color: "#3F3F46",
              paddingRight: "0",
              flexShrink: 0,
            }}
          >
            {content}
          </span>
        ))}
      </div>
    </div>
  );
}
